import {z} from 'zod';

// ミッション
export const Mission = z.object({
  id: z.number().int().min(1).max(5), // ミッションID（1-5）
  name: z.string(), // ミッション名
  description: z.string(), // ミッションの説明文（ユーザー向けの行動指示）
  completed: z.boolean(), // ミッション達成状況
});

export type MissionType = z.infer<typeof Mission>;

// GET /3.0/service/users/me/entry-managements/progress-missions - プログレスミッション達成状況取得
// GET /3.0/users/me/entry-todos/missions - TODOミッション達成状況取得
export const GetMissionsOutput = z.array(Mission);

export type GetMissionsOutputType = z.infer<typeof GetMissionsOutput>;
